import { useWizardContext } from '../Services/WizardContext';
import { IWizardItem } from '../Components/WizardItems/WizardItem';

const useWizardButton = (item: IWizardItem) => {
	const { setWizardData } = useWizardContext();

	const handleClick = () => {
		const type = item?.settings?.action?.type;
		if (type) {
			switch (type) {
				case 'openApp':
					// @ts-ignore
					window.location.href = '/';
					break;
				case 'browser':
					// @ts-ignore
					window.location.href = item.settings?.action.url;
					break;
				case 'redirect':
					let url = '/';
					switch (item?.settings?.action?.destination) {
						case 'wizard_online':
							url = `/case-wizard/${item?.settings?.action?.wizardId}`;
							break;
						case 'measurementHistory':
							url = `/measurement-history/${item?.settings?.action?.wizardKey}`;
							break;
						case 'subscription':
							url = '/moje-predplatne/default';
							break;
						case 'homepage':
							url = '/';
							break;
					}
					// @ts-ignore
					window.location.href = url;
					break;
			}
		} else {
			setWizardData({
				...item.data?.nextStepData,
				step: item.data?.nextStep,
			});
		}
	};

	return { handleClick };
};

export default useWizardButton;
